export default {
  passkey: {
    notSupported: 'Passkey is not supported in your current browser',
    getCredentialFailed: 'Failed to get passkey credential parameters',
    cancelled: 'Passkey login cancelled',
    loginFailed: 'Login failed',
    rpIdMismatch:
      'rpId mismatch: Use rpId=localhost for local development, or configure /.well-known/webauthn for cross-origin',
    verificationFailed: 'Passkey login failed',
  },
}
